<template>
  <LoadingPage v-if="loading" />
  <div class="page" v-else>
    <header class="page-header">
      <h1>برجاء اختيار الشركة</h1>
    </header>

    <div class="cards-grid">
      <div v-for="x in data1" :key="x.cnum" class="card-item">
        <a href="#" @click.prevent="change2(x)" class="card-link">
          <div class="image-wrapper">
            <img
              :src="`${$store.state.imgurl}/clogo/${x.cnum}.png`"
              crossorigin="anonymous"
              @error="handleImageError"
              alt="Company Logo"
            />
          </div>
          <h6>{{ x.cname }}</h6>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LoadingPage from "../components/LoadingPage.vue";
import store from "@/store";
import CryptoJS from "crypto-js";

export default {
  components: { LoadingPage },
  props: ["css"],
  data() {
    return {
      loading: false,
      data1: [],
      data2: "",
    };
  },
  async mounted() {
    this.loading = true;
    try {
      const result = await axios.post(`/admin/allcontracts`, {
        username: store.state.randp.username,
      });
      if (result.status === 200) {
        this.data1 = result.data.data;
      }
    } catch (error) {
      console.error("Error fetching contracts:", error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    handleImageError(e) {
      // Fallback placeholder if company logo fails to load
      e.target.src = "https://placehold.co/200x100?text=No+Logo";
    },
    async change2(x) {
      try {
        let result = await axios.post("/user/authenticate2", {
          data: JSON.stringify({
            cnum: x.cnum,
            cname: x.cname,
            caddress: x.address,
            bankinfo: x.bankinfo,
            taxnum: x.taxnum,
            paymentdata: x.paymentdata
          }),
        });
        
        if (result.status === 200) {
          const user = [result.data.data];
          const passphrase = process.env.VUE_APP_SOCKET_ENDPOINT;
          const data = JSON.stringify(user);
          const crept = CryptoJS.AES.encrypt(data, passphrase).toString();

          localStorage.setItem('data', crept);
          this.$cookies.set("token", result.data.data.token);

          window.location.href = `${this.$store.state.surl}/AdminDashboard/Home`;
        }
      } catch (error) {
        console.error("Authentication failed:", error);
      }
    },
  },
};
</script>

<style scoped>
.page {
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  direction: rtl; /* Sets primary layout flow for Arabic text */
}

.page-header h1 {
  text-align: center;
  font-size: 1.75rem;
  margin-bottom: 2.5rem;
  color: #333;
  font-weight: 700;
}

/* Flexibly displays items without manual percentages or floats */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 1.5rem;
  justify-content: center;
}

.card-item {
  background-color: #ffffff;
  border: 1px solid #eef0f2;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.card-link {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
  text-decoration: none;
  color: #333;
}

.image-wrapper {
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
}

.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

h6 {
  margin: 0;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 600;
  word-break: break-word;
  transition: color 0.2s ease;
}

/* Modern Hover Effects */
.card-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.08);
  border-color: v-bind("css.color");
}

.card-item:hover h6 {
  color: v-bind("css.color");
}

/* Responsive Rules for Small Devices (Mobile First) */
@media screen and (max-width: 576px) {
  .page-header h1 {
    font-size: 1.35rem;
    margin-bottom: 1.5rem;
  }

  .cards-grid {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 1rem;
  }
  
  .image-wrapper {
    height: 70px;
  }

  h6 {
    font-size: 0.85rem;
  }
}
</style>